import Link from "@/components/_rebrand/Link";
import cn from "classnames";
import { FooterBackgroundColor } from "./Footer.types";

type SmallLinksSectionProps = {
  smallLinksTitle: string;
  smallLinkColumns: {
    title: string;
    links: {
      title: string;
      href: string;
    }[];
  }[];
  backgroundColor: FooterBackgroundColor;
}

export const SmallLinksSection = ({ smallLinksTitle, smallLinkColumns, backgroundColor }: SmallLinksSectionProps) =>
  <div className="pb-5">
    <div className="grid grid-cols-12 gap-y-5 gap-gutter-mobile md:gap-x-gutter-desktop">
      <div className="col-span-12 xl:col-span-4">
        <p className="text-10/14 uppercase">{smallLinksTitle}</p>
      </div>

      <div className="col-span-12 xl:col-span-8">
        <div className="grid grid-cols-2 xl:grid-cols-4 gap-y-5 gap-gutter-mobile md:gap-x-gutter-desktop">
          {smallLinkColumns.map((column, index) => (
            <div key={`small-link-column-${column.title?.replace(/\s/g, '-') ?? index}`} className="flex flex-col gap-3">
              <p className="text-10/14 uppercase">{column.title}</p>
              <ul className="flex flex-col gap-2">
                {column.links.map((link) => (
                  <li key={`footer-link-${link.href}`}>
                    <Link
                      href={link.href}
                      className={cn('hover:text-white duration-200 transition-colors ease-in-quad', {
                        'text-violet-200': backgroundColor === 'violet',
                      })}
                    >
                      {link.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </div>
  </div>
